import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.css',
  imports:[ReactiveFormsModule]
})
export class ConfirmationComponent {
  token: string = '';
  errorToConfirm: boolean = false;
  showSuccessMessage: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  onConfirm() {
    this.authService
    .basicUserConfirmation(this.token)
    .subscribe({
      next: (response) => {
        this.errorToConfirm = !response.data;
        
        if(!this.errorToConfirm){
          this.showSuccessMessage = true;
          this.authService.resetAccessToken();
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        this.showSuccessMessage = false;
        this.errorToConfirm = true;
      },
    });
  }
}